import React from 'react';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import navbarLogo from '../../images/logo-header.svg';

export default function Header() {
    return (
        <header>
            <Navbar bg="light" exlpand="lg">
                <Container fluid>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link href="/" className="ps-0">Accueil</Nav.Link>
                            <Nav.Link href="/?page=dashboard" className="ms-md-5">Dashboard</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                    <Navbar.Brand href="https://pcen.fr/" target="_blank">
                        <img src={navbarLogo} alt="logo" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                </Container>
            </Navbar>
        </header>
    )
}